import React from 'react';
import './style.css';
import ShopList from "../ShopList";

const ShopListWrapperMobile = ({shopsQueryState, gtmClassName}) => {
    return (
        <div id="react-mobile-shop-list" className={gtmClassName}>
            <div className="react-shop-mobile-list-wrapper storelocator">
                <ShopList shopsQueryState={shopsQueryState} />
            </div>
        </div>
    );
}

export default ShopListWrapperMobile;